import React from 'react';
import { ColumnsType } from './columnsType';
import { isMobile } from '../helpers/isMobile';
import { TranslationKeys } from './translationKeys';
import { userInfoStore } from '../../store/userInfoStore';
import { isTopC } from '../helpers/skinHelper';
import { cryptoCurrencies } from './cryptoCurrencies';
import { GameIds } from './gameIds';
// import { GamesLogoSrc } from './gamesLogoSrc';

export const allGameTableColumns = [
  {
    title: TranslationKeys.Game,
    dataKey: 'gameName',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <>
        {/* <img src={GamesLogoSrc[spinInfo.gameName]} className="game-favicon" alt='#' /> */}
        <p className={`game-favicon ${[spinInfo.gameName]}`} />
      </>
    ),
  },
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: !isMobile(),
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (data) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[data.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'default',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: ({ odd, gameId }) => {
      if (gameId === GameIds.Plinko || gameId === GameIds.Fishing) {
        return `≈ ${odd}x`;
      }
      return `${odd}x`;
    },
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (data) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[data.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];
